import { Component, OnInit } from '@angular/core';
import { NavigationActionBase } from '../../navigation-action-base';

/**
 * Tenant navigation component
 */
@Component({
  selector: 'tenant-navigation',
  templateUrl: './tenant-navigation.component.html'
})
export class TenantNavigationComponent extends NavigationActionBase implements OnInit {
  /**
   * ngOnInit
   */
  ngOnInit(): void {
    super.ngOnInit();
  }
}
